import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/core/ui/components';
import { TenantWizard } from '../components/wizard';

export function TenantOnboardingPage() {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/tenants')}
          leftIcon={<ArrowLeft className="w-4 h-4" />}
        >
          Back to Tenants
        </Button>
      </div>

      <div className="text-center mb-8">
        <h1 className="text-2xl font-bold text-theme">Create New Tenant</h1>
        <p className="text-theme-secondary mt-1">
          Follow the steps below to set up a new tenant on the platform
        </p>
      </div>

      <TenantWizard
        onComplete={() => navigate('/tenants')}
        onCancel={() => navigate('/tenants')}
      />
    </div>
  );
}
